import { render, staticRenderFns } from "./AccettazioneSsnListaPage.vue?vue&type=template&id=c2732aac&scoped=true"
import script from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2732aac",
  null
  
)

export default component.exports